export function getIconName(name) {
  return `/svg/icons/${name}.svg`;
}
export function getIllustrationsName(name) {
  return `/svg/illustrations/${name}.svg`;
}
